import { render } from "./xtx-confirm.vue?vue&type=template&id=a3586a62&scoped=true"
import script from "./xtx-confirm.vue?vue&type=script&lang=js"
export * from "./xtx-confirm.vue?vue&type=script&lang=js"

import "./xtx-confirm.vue?vue&type=style&index=0&id=a3586a62&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3586a62"]])

export default __exports__